/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { StartToggle } from './StartToggle';

export namespace NotaryDocumentHeader {
  export interface Props {}
}

const styles = StyleSheet.create({
  preview: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.white,
    height: 48,
    position: 'relative',
  },
  previewHeader: {
    ...fonts.UntitledSans,
    fontWeight: 'bold',
    fontSize: 18,
    ...mixins.marginVertical(10),
  },
  toggle: {
    position: 'absolute',
    right: 0,
  },
});

const HEADER_TEXT = 'Document Preview';

export const NotaryDocumentHeader: React.FC<NotaryDocumentHeader.Props> = () => {
  const callId = useRootSelector(state => state.callDetails!.id);

  return (
    <div className={css(styles.preview)} data-dd-privacy="allow">
      <h1 className={css(styles.previewHeader)}>{HEADER_TEXT}</h1>
      <div className={css(styles.toggle)}>
        <StartToggle callId={callId} />
      </div>
    </div>
  );
};
